import React from 'react';
import { EmployeeReviewFieldKey, IEmployeeReviewField } from 'types';
import { Button } from '../Button';
import { Modal, ModalAvatar, ModalFooter } from '../Modal';
import { Entity, HeaderContent, Instructions, Name, ReviewRow, ReviewTable, Row, StyledHeaderCell, StyledModalHeader, TableBody, TableContainer, TableHead } from './styles';

interface IReviewUserProps {
  isActive: boolean;
  isLoading: boolean;
  onIgnore: () => void;
  onApprove: () => void;
  onClose: () => void;
  userName: string;
  avatarUrl?: string;
  hasPaymentMethod?: boolean;
  entityName?: string;
  reviewObject: Record<EmployeeReviewFieldKey, IEmployeeReviewField>;
}

const ReviewUser: React.FC<IReviewUserProps> = ({ isActive = false, avatarUrl, onClose, userName, isLoading, entityName, hasPaymentMethod, onIgnore, onApprove, reviewObject }) => (
  <Modal maxWidth={740} isActive={isActive} onClose={onClose} data-cy="review-user-modal">
    <StyledModalHeader>
      <ModalAvatar
        image={avatarUrl}
        username={userName}
        // TODO: hook up payment method to this prop
        hasPaymentMethod={hasPaymentMethod}
      />
      <HeaderContent>
        <Name>{userName}</Name>
        {entityName && <Entity>{entityName}</Entity>}
      </HeaderContent>
    </StyledModalHeader>

    <Instructions>Review the differences in employee information, then choose to approve or ignore this user&apos;s access.</Instructions>

    {reviewObject && (
      <TableContainer>
        <ReviewTable>
          <TableHead>
            <Row>
              <StyledHeaderCell />
              <StyledHeaderCell align="left">Invitation</StyledHeaderCell>
              <StyledHeaderCell align="left">Personal</StyledHeaderCell>
              <StyledHeaderCell />
            </Row>
          </TableHead>

          <TableBody>
            <ReviewRow label="First Name" expected={reviewObject[EmployeeReviewFieldKey.FIRST_NAME].employee} received={reviewObject[EmployeeReviewFieldKey.FIRST_NAME].user} />
            <ReviewRow label="Last Name" expected={reviewObject[EmployeeReviewFieldKey.LAST_NAME].employee} received={reviewObject[EmployeeReviewFieldKey.LAST_NAME].user} />
            <ReviewRow label="Invite Method" expected={reviewObject[EmployeeReviewFieldKey.IDENTITY_RECIPIENT].employee} received={reviewObject[EmployeeReviewFieldKey.IDENTITY_RECIPIENT].user} />
          </TableBody>
        </ReviewTable>
      </TableContainer>
    )}
    <ModalFooter columns={2}>
      <Button disabled={isLoading} appearance="white" size="large" onClick={onIgnore} label="Ignore" />
      <Button isProcessing={isLoading} appearance="primary" size="large" onClick={onApprove} label="Approve" />
    </ModalFooter>
  </Modal>
);

export default ReviewUser;
